import { apiCall } from "../../services/api-service";

export const getquickreportApi = async () => {
    const response = await apiCall("get", "report/get_quick_report");
    return response?.data;
};


export const exportquickApi = async (apivalue, formattedFromDate, formattedToDate, expected_date) => {
    return apiCall("post", `report/${apivalue}`, {
        from_date: formattedFromDate,
        to_date: formattedToDate,
        expected_date: expected_date,
    });
};


export const downloadBase64File = (base64String, fileName) => {
    const binary = atob(base64String);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
